import { Typography } from "@graphy/ui";
import Image, { StaticImageData } from "next/image";
import SectionHeading, { SectionHeadingType } from "../atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export type graphyAssistPropsType = {
  title: SectionHeadingType;
  features: string[];
  ctas: CtaType[];
  description: string;
  image: {
    src: StaticImageData;
    alt: string;
  };
  footerText?: string;
};

const GraphyAssist = ({
  title,
  features,
  ctas,
  description,
  image,
  footerText,
}: graphyAssistPropsType) => {
  return (
    <div
      style={{
        background:
          "linear-gradient(279.72deg, rgba(241, 240, 255, 0.555876) -1.94%, #F1F0FF 41.28%, rgba(216, 250, 233, 0.913201) 82.95%)",
      }}
      className="mx-4 rounded-3xl md:mx-0 md:rounded-none"
    >
      <div className="page-max-width mx-0 flex flex-col justify-between gap-6 px-4 py-3 md:mx-auto md:flex-row md:items-center md:px-0 md:py-12">
        <div>
          <SectionHeading heading={title} key={"product-statsCards-heading"} />
          <Typography
            fontSize="text-title6"
            fontWeight="font-normal"
            colorClass="text-grey-4"
            className="mt-[6px]"
          >
            {description}
          </Typography>
          <div className="mb-3 mt-4 flex flex-col gap-3 md:my-6">
            {features.map((feature, index) => {
              return (
                <div key={feature} className="flex items-center gap-2">
                  <div className="min-w-5 h-[14px] min-w-[14px] rounded-full bg-green-3"></div>
                  <p className=" text-body-12 font-normal text-grey-4 ">
                    {feature}
                  </p>
                </div>
              );
            })}
          </div>
          <CtaButtonGroup ctas={ctas} gap="gap-4" fullWidthOnMobile={false} />
          {footerText && (
            <div className="mt-6 max-w-[580px] w-full text-left">
              <Typography
                fontSize="text-body"
                colorClass="text-grey-4"
                fontWeight="font-normal"
                align="text-left"
                className="!mb-0 !mt-0"
              >
                {footerText}
              </Typography>
            </div>
          )}
        </div>
        <Image
          src={image?.src!}
          alt={image?.alt!}
          width={0}
          height={0}
          sizes="100vw"
          className="mt-4 h-auto w-full md:mt-0 md:h-[228px] md:w-[350px]"
        />
      </div>
    </div>
  );
};

export default GraphyAssist;
